module.exports = __webpack_public_path__ + "static/carloconti-a86390d17afbf839b538e4fc0418d33f.png";